// extracted by mini-css-extract-plugin
export var equalColumn = "_ia-0";